import axios, { AxiosRequestConfig } from 'axios'
import { jwtToken } from '@jsh/helper/utils'
import router from '../../router/index'
import { getRefreshToken, getToken, setRefreshToken, setToken } from '@/utils'
import { Api } from '@/apis'

const config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  timeout: 30 * 60 * 1000 // Timeout
  // withCredentials: true, // Check cross-site Access-Control
}

// 接口白名单 这里面的接口地址不会在headers里面添加token
const WHITE_LIST: string[] = [
  Api.login,
  Api.refreshToken,
  Api.requestResign,
  Api.queryResign,
  Api.forwardRequest,
  '/api/open/sentry/test-post-data-demo'
]

const _axios = axios.create(config)

_axios.interceptors.request.use(
  function (config: AxiosRequestConfig) {
    if (config.url && WHITE_LIST.includes(config.url)) {
      return config
    }
    config.headers = config.headers || {}

    const accessToken = getToken()
    const refreshToken = getRefreshToken()
    return jwtToken.run({
      accessToken,
      refreshToken,
      isRefreshApi: Api.refreshToken === config.url,
      // 刷新 token，刷新接口要放到接口白名单中，防止刷新token的接口被拦截
      updateAccessToken: () => axios.post(Api.refreshToken, {
        // 接口参数
        refreshToken
      }),
      // 有效 token 处理器
      validHandler (newAccessToken, newRefreshToken) {
        // 重新保存 token 的值, 这里为业务方保存token的逻辑
        setToken(newAccessToken)
        setRefreshToken(newRefreshToken)
        // 业务逻辑
        if (config.headers) config.headers.Authorization = 'Bearer ' + newAccessToken
        // 返回 axios 的配置项发送接口请求
        return config
      },
      // 无效 token 处理器
      invalidHandler (failType) {
        // token 失效，重定向到登录页面
        router.push('/login').catch(_ => _)
        return config
      }
    })
  },
  function (error) {
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    const { response } = error
    if (response) {
      switch (response.status) {
        case 401:
          router.push('/login').catch(_ => _)
          break
        case 404:
          // 找不到接口
          break
        case 500:
          // 服务器错误
          break
        case 502:
          // 服务器错误
          break
        default:
          break
      }
      return Promise.reject(error.response)
    }

    return Promise.reject(error)
  }
)

export default _axios
